import { makeStyles } from 'tss-react/mui'
import bg from 'src/assets/images/errorbg.png'
import { lato, nunito_sans } from '@styles/fonts'
const useStyles = makeStyles()((theme) => ({
  root: {
    height: '100vh',
    width: '100%',
    backgroundImage: `url(${bg.src})`,
    // backgroundSize: 'cover',
    backgroundSize: '100% 100%',
    marginTop: '40px',
    [theme.breakpoints.down('md')]: {
      marginTop: '-20px',
    },
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '90vh',
    padding: '0px 10px',
  },
  heading: {
    fontFamily: nunito_sans.style.fontFamily,
    fontSize: '84px',
    fontWeight: 800,
    lineHeight: '83px',
    letterSpacing: '0em',
    textAlign: 'center',
    marginBottom: '130px',
    textTransform: 'uppercase',
    [theme.breakpoints.down('md')]: {
      fontSize: '48px',
      fontWeight: 800,
      lineHeight: '58px',
      marginBottom: '100px',
    },
  },
  subHeading: {
    fontFamily: lato.style.fontFamily,
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: '24px',
    letterSpacing: ' 0em',
    textAlign: 'center',
    marginBottom: '50px',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      fontSize: '18px',
      lineHeight: '21px',
    },
  },
  btnContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    maxWidth: '400px',
    width: '100%',
    // '& > *': {
    //   marginRight: '20px',
    // },
  },
  button: {
    fontFamily: nunito_sans.style.fontFamily,
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: '22px',
    letterSpacing: '0em',
    textAlign: 'center',
    textTransform: 'uppercase',
    background: 'black',
    color: 'white',
    width: '100%',
    border: 'none',
    [theme.breakpoints.down('md')]: {
      fontSize: '14px',
    },
  },
  gradientWrapper: {
    maxWidth: '178px',
    [theme.breakpoints.down('md')]: {
      maxWidth: '138px',
    },
  },
}))

export default useStyles
